<template>
  <v-dialog
    v-model="showAddForm"
    persistent
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <v-card-title>
        <h2>Add Item</h2>
      </v-card-title>
      <br>
      <v-card-text>
        <v-form
          ref="form"
          v-model="valid"
        >
          <v-text-field
            v-model="itemName"
            label="Item Name"
            outlined
            :rules="[(v) => !!v || 'This field is required']"
            dense
            light
          />
          <v-row>
            <v-col cols="6">
              <v-text-field
                v-model="quantity"
                label="Quantity"
                outlined
                type="number"
                dense
                :rules="[(v) => !!v || 'This field is required']"
                light
              />
            </v-col>
            <v-col cols="6">
              <v-text-field
                v-model="unitPrice"
                label="Unit Price"
                outlined
                :rules="[(v) => !!v || 'This field is required']"
                dense
                type="number"
                light
              />
            </v-col>
          </v-row>
          <v-text-field
            v-model="amount"
            label="Amount"
            type="number"
            outlined
            disabled
            dense
            light
          />
        </v-form>
        <div>
          <v-btn
            class="next-style"
            elevation="0"
            color="#64CA7F"
            @click="addItem()"
          >
            Add
          </v-btn>&nbsp;&nbsp;
          <v-btn
            class="cancel-style"
            elevation="0"
            color="#F5F5F5"
            @click="showAddForm = false"
          >
            Cancel
          </v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import Constants from 'src/constants';
export default {
    name: 'AddInvoiceItems',
    data: () => ({
        showAddForm: true,
        itemName: null,
        quantity: 1,
        unitPrice: 0,
        amount: 0,
        valid: false,

    }),
    computed: {
    },
    watch: {
        showAddForm: function (newval, oldval) {
            if (newval === false) {
                this.$emit('closed');
            }
        },
        quantity (newval, oldval) {
            this.calculateAmount();
        },
        unitPrice (newval, oldval) {
            this.calculateAmount();
        },
    },
    methods: {
        addItem () {
            if (this.$refs.form.validate() === false) {
                this.$store.dispatch(
                    'alert/onAlert',
                    {
                        message: 'Please fill the required fields before proceeding',
                        type: Constants.ALERT_TYPE_ERROR,
                    },
                    { root: true },
                );
                return;
            }
            const data = {
                itemName: this.itemName,
                quantity: this.quantity,
                unitPrice: this.unitPrice,
                amount: this.amount,
            };
            this.$emit('add', data);
            this.showAddForm = false;
        },
        calculateAmount () {
            this.amount = this.quantity * this.unitPrice;
        },
    },
};
</script>

<style scoped>
.next-style,
.cancel-style {
    height: 30px !important;
    font-size: 12px;
    width: 80px;
    font-weight: lighter !important;
    text-transform: none !important;
}

.theme--dark.v-list {
    background-color: white !important;
}

.theme--dark>>>.v-list-item {
    color: #37474f !important;
}

.v-form>>>.v-text-field.v-text-field--enclosed .v-text-field__details {
    margin-bottom: 0px !important;
}
</style>
